<!-- @format -->

<template>
	<div>
		<div class="text-bold table-color">
			Select customer from bellow to show customer's history
		</div>
		<div>
			<ve-table
				:rows="rowsList"
				:columns="columnsList"
				:onCellClick="onCellClick"
				:onRowDoubleClick="onRowDoubleClick"
				:sort-options="sortOptions"
			>
			</ve-table>
		</div>
	</div>
</template>

<script>
import { ref, reactive, onMounted } from '@vue/composition-api'
import Store from '@/store'
import { useQuery } from '@vue/apollo-composable'
import GetCustomerListQuery from '@/_srcv2/pages/admin/customer-history/graphql/GetCustomerListQuery.graphql'
import storeCustomerHistory from '@/_srcv2/pages/admin/customer-history/store/useCustomerHistoryStore.js'

export default {
	name: 'SelectCustomer',
	setup() {
		const options = reactive({
			fetchPolicy: 'no-cache',
		})
		const { refetch: refetchCustomers } = useQuery(
			GetCustomerListQuery,
			() => ({
				company_id: Store.getters.getUserCurrentCompany,
			}),
			options,
		)
		const refetchData = () => {
			refetchCustomers().then((result) => {
				rowsList.value = result.data.customers
				console.log('rowsList.value', rowsList.value)
			})
		}
		const { showSearch, showHistory } = storeCustomerHistory()
		onMounted(() => {
			showSearch.value = true
			refetchData()
		})
		const sortOptions = {
			enabled: true,
			initialSortBy: { field: 'customer_title', type: 'asc' },
		}
		// get columns
		const { columnsList } = storeCustomerHistory()
		// get rows
		const rowsList = ref([])
		// *-----------------------------------------------------------------------------
		const { customer } = storeCustomerHistory()
		const onCellClick = (params) => {
			if (params.column.field === 'select') {
				console.log(params.row)
				customer.value = params.row
				showSearch.value = false
				showHistory.value = true
			}
			// setQueryVariables(params.row).then(() => {
			//   setComponentState()
			// })
		}
		const onRowDoubleClick = (params) => {
			console.log(params.row)
			customer.value = params.row
			showSearch.value = false
			showHistory.value = true
		}
		return {
			showSearch,
			sortOptions,
			columnsList,
			rowsList,
			onCellClick,
			onRowDoubleClick,
		}
	},
}
</script>

<style scoped></style>
